export * from './modal-demo.component';
export * from './modal-demo-form.component';
export * from './modal-demo-tiled-form.component';
